<template>
  <artisio-modal size="lg" :visible="visible" :title="$t('Movement History')"
                 :show-confirmation="false" :hide-footer="true"
                 @hidden="$emit('hidden')">
    <movement-history-list :entries="entries" :loading="loading"/>
  </artisio-modal>
</template>

<script>
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal";
  import InventoryService from "@/modules/inventory/InventoryService";
  import MovementHistoryList from "./MovementHistoryList";

  export default {
    name: "MovementHistoryModal",
    components: {ArtisioModal, MovementHistoryList},
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      inventoryUuid: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        entries: [],
        loading: false,
      };
    },
    watch: {
      visible(val) {
        if (val && this.inventoryUuid) {
          this.fetchHistory();
        }
      }
    },
    methods: {
      async fetchHistory() {
        this.loading = true;
        const response = await InventoryService.getMovementHistory(this.inventoryUuid);
        this.loading = false;
        if (response.success) {
          this.entries = response.body.results || response.body || [];
        } else {
          this.entries = [];
        }
      }
    }
  }
</script>
